import React from 'react';
import Image from 'next-export-optimize-images/image';

const Logo = (props: React.HTMLAttributes<HTMLAnchorElement | HTMLSpanElement>) => {
  return (
    <span aria-label="Oviva" data-logo-type={0} {...props}>
      <Image className="logo-image w-[98px] h-[31px] md:w-[120px] md:h-[38px]" src="/images/logo.svg" width={120} height={38} alt="Oviva AG" />
    </span>
  );
};

export default Logo;
